import { styled } from '@zoopla-eng/zds-components/themes';

export const Heading = styled('h1', {
    color: '$textContrast',
    fontGroup: 'toaster'
});

export const SubHeading = styled('p', {
    fontGroup: 'whisk',
    color: '$textContrast'
});

export const SearchLabel = styled('label', {
    fontGroup: 'ladle',
    color: '$textContrast'
});

export const Search = styled('div', {
    display: 'flex',
    columnGap: '$S400',

    '> div': {
        flexGrow: 1
    },

    input: {
        height: '$L200'
    }
});

export const HelpLabel = styled('label', {
    fontGroup: 'fork',
    color: '$textContrast'
});
